import { sliceName } from "./initialState";

const emptyArray = [];

export const selectUseBonus = (state) => state[sliceName].useBonus;
export const selectFilters = (state) => state[sliceName].filters;
export const selectBonusTotal = (state) => state[sliceName].total;
export const selectIsBonusLoading = (state) => state[sliceName].loading;
export const selectBonusHistory = (state) => state[sliceName].history ?? emptyArray;
export const selectBonusFiltersPage = (state) => state[sliceName].filters.page;
export const selectModalReadyToShow = (state) => state[sliceName].modalReadyToShow;
